<template>
  <div class="row">
  <b-card class="col-8 m-1">
    <b-row>

      <b-form-input
        v-model="filters.search"
        placeholder="Buscar por nombre o cédula."
        type="text"
        class="col-10 mb-1"
      />
      
      <!-- <v-select
        id="establecimiento"
        v-model="filters.establecimiento"
        :options="establecimientosOpts"
        placeholder="Buscar por establecimiento."
        :reduce="(option) => option.value"
        label="text"
        class="col-4 mb-1"
      />

      <v-select
        id="estado"
        v-model="filters.estadoTerapia"
        :options="estadosOpts"
        placeholder="Buscar por estado."
        :reduce="(option) => option.value"
        label="text"
        class="col-4 mb-1"
      /> -->

      

    
    </b-row>
    <div class="row">

      <flat-pickr 
        class="form-control col-3 mx-2" 
        v-model="filters.fechaDesde" 
        locale="es" 
        placeholder="Desde"
      />

      <flat-pickr 
        class="form-control col-3 mr-1" 
        v-model="filters.fechaHasta" 
        locale="es" 
        placeholder="Hasta"
      />
        <b-col
        class="col d-flex align-items-center justify-content-start mb-1 mb-md-0"
      >
        <b-button 
          variant="primary" 
          @click="buscarTerapiaProgramada"
        >
          <font-awesome-icon icon="magnifying-glass" style="color: white" />
          <span style="color: white"> Buscar</span>
        </b-button>
      </b-col>
      </div>


  </b-card> 
  <b-card class="col-3 mt-1 mb-1 ml-1">
    <h5>Observaciones: </h5>
    <div class="row my-1">      
      <div class="col">
        <label> <b>Coberturas faltantes:</b></label> <span> {{ coberturasFaltantes }} (total)</span> 
      </div>
      <div class="col">
        <b-form-checkbox v-model="filters.coberturasFaltantes"></b-form-checkbox>
      </div>
   
    </div>
    <div class="row">
      <div class="col">
        <label><b>Sesiones Incompletas:</b></label> <span>{{ sesionesIncompletas }} (total)</span>
      </div>
      <div class="col">
        <b-form-checkbox v-model="filters.sesionesIncompletas"></b-form-checkbox>

         
      </div>
      
    </div>
  </b-card>
  </div>
</template>

<script>
import vSelect from 'vue-select';
import flatPickr from "vue-flatpickr-component";
import { establecimientosService } from '../../../administracion/services';
import { getEstablecimientoLS } from '../../../../shared/helpers';
import { terapiasService } from '../../services';
import { terapiasMapper } from '../../helpers';

export default {

  name: 'FiltersTerapias',

  components: {
    vSelect,
    flatPickr,
  },



  // created() {
  //   this.loadInitData();
  // },

  props: {
    numSinCobertura:{
      required : false,
      default : '0'
    },
    numSinCompletar: {
      required : false,
      default : '0'
    }
  },

    watch: {
    numSinCobertura:{
      deep : true,
      immediate:true,
      handler(newValue) {
        this.coberturasFaltantes = newValue
      }
    },
      numSinCompletar:{
      deep : true,
      immediate:true,
      handler(newValue) {
        this.sesionesIncompletas = newValue
      }
    },
   
  },

  data() {
    return {
      

      filters:{
        search: null,
        establecimiento: null,
        estadoTerapia: null,
        fechaDesde: null,
        fechaHasta: null,
        coberturasFaltantes: false,
        sesionesIncompletas:false
      },

      establecimientosOpts: [],
      estadosOpts: [
        
      ],
      coberturasFaltantes:'0',
      sesionesIncompletas:'0'
    }
  },

  methods: {

    async loadInitData(){
      this.coberturasFaltantes = this.numSinCobertura
      this.sesionesIncompletas = this.numSinCompletar
    },

     
    async loadDataTable() {
      

      const params = {
        establecimiento : getEstablecimientoLS().id,
        search: this.filters.search,
        fechaDesde: this.filters.fechaDesde,
        fechaHasta: this.filters.fechaHasta,
        coberturasFaltantes : this.filters.coberturasFaltantes,
        sesionesIncompletas : this.filters.sesionesIncompletas
      };

      const responseTerapias = await terapiasService.getAll(params);
      console.log("res", responseTerapias)
      this.sesionesIncompletas = responseTerapias.numSinCompletar
      this.coberturasFaltantes = responseTerapias.numSinCobertura
      if(!responseTerapias) return;
      const terapiasMap = responseTerapias.solicitudes.map( t => terapiasMapper(t));
      
      
     
      return terapiasMap;
    },


    async buscarTerapiaProgramada(){
      const terapiasResponse = await this.loadDataTable()
      if (terapiasResponse) {
        this.$emit('terapias-encontradas', terapiasResponse);
      }
    },



  }
}
</script>
